import userUIStore from './userUIStore.js';
import userDataStore from './userDataStore.js';

export default {
  modules: {
    ui: userUIStore,
    data: userDataStore,
  },
};
